import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/[username]/page.tsx");
